import { Formater } from './formater'

export interface ITableColumn {
  name: string
  label: string
  field: string | ((row: any) => number)
  required?: boolean
  align?: 'left' | 'right' | 'center'
  sortable?: boolean
  format?: (val: any) => string | number
}

export const TableUtils = {
  calculatePercent(numerator: number, denominator: number): number {
    if (numerator && denominator) {
      const percent = (numerator / denominator) * 100
      return Number(Formater.round(percent))
    }
    return 0
  },

  formatNumber(num: number): string {
    const result = Formater.numberFormat(num)
    return typeof result === 'string' ? result : result.toString()
  },

  formatPercent(val: number | undefined): string {
    return `${val || 0}%`
  },
}
